module.exports = __webpack_public_path__ + "img/80728ed.jpg";